// CSS
import { fileDownload } from 'Admin/Component/AdFunc';
import { useState } from 'react';
import '_Asset/css/User/Page/UiComponent/modal.css'

const Modal = () => {

  const [popUpState, setPopUpState] = useState(false);
  const [popUpState2, setPopUpState2] = useState(false);
  const [toastState, setToastState] = useState(false);
  const [toastIdx, setToastIdx] = useState('');

  const toastArr = [
    {
      name: 'Toast Type 1',
      class: 'Class: [toast / success, warning, error, notice, info]',
      toastList: [
        // Sample
        {sample: true, class: 'success', icon: 'icofont-verification-check', title: 'Success', content: 'Anyone with access can view your invited visitors.'},
        {sample: true, class: 'warning', icon: 'icofont-exclamation', title: 'Warning', content: 'Anyone with access can view your invited visitors.'},
        {sample: true, class: 'error', icon: 'icofont-close', title: 'Error', content: 'Anyone with access can view your invited visitors.'},
        {sample: true, class: 'notice', icon: 'icofont-notification', title: 'Notice', content: 'Anyone with access can view your invited visitors.'},
        {sample: true, class: 'info', icon: 'icofont-info', title: 'Info', content: 'Anyone with access can view your invited visitors.'},
        // Real
        {class: 'success', icon: 'icofont-verification-check', title: 'Success', content: 'Anyone with access can view your invited visitors.'},
        {class: 'warning', icon: 'icofont-exclamation', title: 'Warning', content: 'Anyone with access can view your invited visitors.'},
        {class: 'error', icon: 'icofont-close', title: 'Error', content: 'Anyone with access can view your invited visitors.'},
        {class: 'notice', icon: 'icofont-notification', title: 'Notice', content: 'Anyone with access can view your invited visitors.'},
        {class: 'info', icon: 'icofont-info', title: 'Info', content: 'Anyone with access can view your invited visitors.'},
      ]
    }
  ]

  return (
    <div className="componentBox">
      <div className="pageTit">
        <h2>Modal <button type="button" className="btn round_10 sm sfrtBlue" onClick={() => fileDownload('ui_component', 'pgui.css')}>UI Component CSS 다운로드</button></h2>
        <p>Components: <span>Modal, Toast</span></p>
      </div> 

      <div className="useWay">
        <h2>How to use the Modal kit</h2>
				<p>Click Modal to copy and paste where you want to use it.</p>
        <p>Bagic Class: <span>modal / toast</span></p>
        <p>Ex. class="<span>modal type_1 show</span>"</p>
      </div>

      <div className="layoutCont">
        <p className="copyInfo"><i className="icofont-exclamation-circle"></i>버튼을 눌러 샘플 팝업을 띄우고, 태그를 복사 할 수 있습니다.</p>

        <div className="tit">
          <h2>Modal Type 1</h2>
          <p>Class: [modal, type_1, show]</p>
        </div>

        {/* Sample Modal type_1 */}
        <div className="modal sample">
          <div className="modalBox">
            <div className="modalHeader">
              <h2>Sample modal header</h2>
              <button type="button" className="icofont-close-line"></button>
            </div>

            <div className="modalBody">
              <p>테스트 텍스트입니다.</p>
              <p>테스트 텍스트입니다.</p>
              <p>테스트 텍스트입니다.</p>
              <p>테스트 텍스트입니다.</p>
            </div>

            <div className="modalFoot">
              <button type="button" className="btn sm round_10 sfrtBlue" onClick={() => setPopUpState(!popUpState)}>팝업 보기</button>
              <button type="button" className="btn sm round_10 black_edge" onClick={() => setPopUpState(!popUpState)}>태그 복사</button>
            </div>
          </div>
        </div>
        {/* Real Modal Type_1 */}
        <div className={`${popUpState ? 'show' : ''} modal`}>
          <div className="modalBox">
            <div className="modalHeader">
              <h2>Sample modal header</h2>
            </div>

            <div className="modalBody">
              <p>테스트 텍스트입니다.</p>
              <p>테스트 텍스트입니다.</p>
              <p>테스트 텍스트입니다.</p>
              <p>테스트 텍스트입니다.</p>
            </div>

            <div className="modalFoot">
              <button type="button" className="btn sm round_10 sfrtBlue" onClick={() => setPopUpState(!popUpState)}>확인</button>
              <button type="button" className="btn sm round_10 black_edge" onClick={() => setPopUpState(!popUpState)}>닫기</button>
            </div>
          </div>
        </div>
      </div>

      <div className="layoutCont">
        <p className="copyInfo"><i className="icofont-exclamation-circle"></i>버튼을 눌러 샘플 팝업을 띄우고, 태그를 복사 할 수 있습니다.</p>

        <div className="tit">
          <h2>Modal Type 2</h2>
          <p>Class: [modal, type_2, show]</p>
        </div>

        {/* Sample Modal type_2 */}
        <div className="modal sample">
          <div className="modalBox">
            <div className="modalHeader">
              <h2>Sample modal header</h2>
            </div>

            <div className="modalBody">
              <p>테스트 텍스트입니다.</p>
              <p>테스트 텍스트입니다.</p>
              <p>테스트 텍스트입니다.</p>
              <p>테스트 텍스트입니다.</p>
            </div>

            <div className="modalFoot">
              <button type="button" className="btn sm round_10 sfrtBlue" onClick={() => setPopUpState2(!popUpState2)}>팝업 보기</button>
              <button type="button" className="btn sm round_10 black_edge" onClick={() => setPopUpState2(!popUpState2)}>태그 복사</button>
            </div>
          </div>
        </div>
        {/* Real Modal type_2 */}
        <div className={`${popUpState2 ? 'show' : ''} modal`}>
          <div className="modalBox">
            <div className="modalHeader">
              <h2>Sample modal header2</h2>
            </div>

            <div className="modalBody">
              <p>테스트 텍스트입니다.</p>
              <p>테스트 텍스트입니다.</p>
              <p>테스트 텍스트입니다.</p>
              <p>테스트 텍스트입니다.</p>
            </div>

            <div className="modalFoot">
              <button type="button" className="btn sm round_10 sfrtBlue" onClick={() => setPopUpState2(!popUpState2)}>확인</button>
              <button type="button" className="btn sm round_10 black_edge" onClick={() => setPopUpState2(!popUpState2)}>닫기</button>
            </div>
          </div>
        </div>
      </div>

      {toastArr.map((key, i) => 
        <div className="layoutCont" key={i}>
          <p className="copyInfo"><i className="icofont-exclamation-circle"></i>X 아이콘을 눌러 Toast Message를 띄우고 태그를 복사 할 수 있습니다.</p>

          <div className="tit">
            <h2>Toast Type 1</h2>
            <p>Class: [toast / success, warning, error, notice, info]</p>
          </div>

          <div className="contWrap">
            {/* Sample Toast Type_1*/}
            {key.toastList.map((item, i) => 
              <div className={`toast ${toastState && toastIdx + 5 === i ? 'show' : ''} ${item.sample ? 'sample' : ''}`} key={i}>
                <div className={`toastBox ${item.class}`}>
                  <div className="toastStatus">
                    <p className={item.icon}></p>
                  </div>

                  <div className="toastMsg">
                    <h2>{item.title}</h2>
                    <p>{item.content}</p>
                  </div>

                  <div className="toastClose">
                    <button type="button" className="icofont-close-line" onClick={() => {setToastState(i < 5 ? true : false); setToastIdx(i)}}></button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  )
}

export default Modal;